import ResponderInstructions from './instructions';

const LLMResponderDetails = () => <ResponderInstructions />;

export default LLMResponderDetails;
